import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

/**
 * /dashboard is a smart shortcut:
 *  - admins → /admin
 *  - regular users → /mes-transactions
 *  - visitors → /login (with redirect back)
 *
 * Rationale: on the PWA installed on the phone, admins clicking the app icon can add a
 * shortcut named "Dashboard" that skips the marketing home and lands on their tools.
 */
export default function DashboardRedirect() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login?redirect=/dashboard", { replace: true });
      return;
    }
    if (user.role === "admin") {
      navigate("/admin", { replace: true });
    } else {
      navigate("/mes-transactions", { replace: true });
    }
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-[color:var(--sl-bg)]">
      <div className="flex items-center gap-3 text-[var(--sl-primary)]" data-testid="dashboard-redirect">
        <Loader2 size={22} className="animate-spin" />
        <span className="font-medium">Redirection…</span>
      </div>
    </div>
  );
}
